import React from 'react';
import Icon from '../../../components/AppIcon';

const QuizHeader = ({ 
  currentQuestion = 1, 
  totalQuestions = 10, 
  timeRemaining = 300,
  chapterTitle = "Introduction to AI"
}) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const getTimeColor = () => {
    if (timeRemaining < 60) return 'text-error';
    if (timeRemaining < 120) return 'text-warning-600';
    return 'text-text-secondary';
  };

  const progressPercentage = (currentQuestion / totalQuestions) * 100;

  return (
    <div className="bg-surface border-b border-border px-4 sm:px-6 lg:px-8 py-4">
      <div className="max-w-4xl mx-auto">
        {/* Header Info */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-3">
            <div className="flex items-center justify-center w-10 h-10 bg-accent-50 rounded-lg">
              <Icon name="Brain" size={20} color="var(--color-accent)" strokeWidth={2} />
            </div>
            <div>
              <h1 className="text-xl font-heading font-semibold text-text-primary">
                Knowledge Assessment
              </h1>
              <p className="text-sm text-text-secondary">
                {chapterTitle}
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            {/* Question Counter */}
            <div className="hidden sm:flex items-center space-x-2 bg-surface-secondary px-3 py-2 rounded-lg">
              <Icon name="FileText" size={16} color="var(--color-text-secondary)" strokeWidth={2} />
              <span className="text-sm font-medium text-text-primary">
                {currentQuestion} of {totalQuestions}
              </span>
            </div>

            {/* Timer */}
            <div className="flex items-center space-x-2 bg-surface-secondary px-3 py-2 rounded-lg">
              <Icon 
                name="Clock" 
                size={16} 
                color={timeRemaining < 60 ? "var(--color-error)" : "var(--color-text-secondary)"} 
                strokeWidth={2} 
              />
              <span className={`text-sm font-medium ${getTimeColor()}`}>
                {formatTime(timeRemaining)}
              </span>
            </div>
          </div>
        </div>

        {/* Progress Bar */}
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-text-primary">
              Question {currentQuestion} of {totalQuestions}
            </span>
            <span className="text-sm text-text-secondary">
              {Math.round(progressPercentage)}% Complete
            </span>
          </div>
          <div className="w-full bg-border-light rounded-full h-2">
            <div 
              className="bg-gradient-to-r from-accent to-accent-600 h-2 rounded-full progress-animation"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>

        {/* Mobile Question Counter */}
        <div className="sm:hidden mt-3 flex justify-center">
          <div className="flex items-center space-x-2 bg-surface-secondary px-3 py-2 rounded-lg">
            <Icon name="FileText" size={16} color="var(--color-text-secondary)" strokeWidth={2} />
            <span className="text-sm font-medium text-text-primary">
              Question {currentQuestion} of {totalQuestions}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuizHeader;